'use client';

import { Link } from 'react-router-dom';

import { LogoIcon } from '@/components';
import { usePathname, useRouter } from '@/hooks';

import { ICurrentUser } from '@/types';

import { UserInfo } from '../UserInfo';
export const Header = ({ user, isShowLink = true }: { user?: ICurrentUser; isShowLink?: boolean }) => {
  const pathname = usePathname() as string;
  const router = useRouter();

  const isHomeActive = pathname?.indexOf('/dashboard') === 0 || pathname === '/';
  const isSettingsActive = pathname?.indexOf('/setting') === 0;
  // const isTemplatesActive = pathname?.indexOf('/templates') === 0;
  return (
    <div className="absolute flex bg-white h-[72px] w-full flex-row items-center pl-10 pr-5 justify-between border-b border-b-gray-100">
      <LogoIcon className="cursor-pointer" onClick={() => router.push('/')} />
      <div className="flex flex-row items-center ">
        {isShowLink && (
          <div className="mr-10 text-sm font-medium text-gray-400">
            <Link to="/dashboard" className={`mr-6 ${isHomeActive ? 'text-gray-900' : ''}`}>
              Home
            </Link>
            {/*<Link href="/templates" className={`mr-6 ${isTemplatesActive ? 'text-gray-900' : ''}`}>*/}
            {/*  My Templates*/}
            {/*</Link>*/}
            <Link to="/setting/personal-settings" className={`${isSettingsActive ? 'text-gray-900' : ''}`}>
              Settings
            </Link>
          </div>
        )}
        {user ? <UserInfo user={user} /> : null}
      </div>
    </div>
  );
};
